import React, { useContext } from 'react';
import CollaborateContext from '../../ContextFiles/CollaborateContext';
import CollaborateConstants from './Constants';
import { Tooltip, Popover, Input, Button, Row, Col } from 'antd';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';

const MainOptions = (props) => {
    const matchingShapeIcon = props.basic_action.extra_actions.find(
        (action) => action.main_action === props.objectShape
      );
    return (
        <div  className='justify-in-center'>
            <Tooltip placement={"top"}
                title={<span className='manrope f-12 white'>
                    {props.basic_action.tooltip}
                </span>}>
                <div className={`tool-box justify-in-center ${props.basic_action.main_action == 'draw' ? 'draw' : ''} ${props.annotateLoader || props.save_loader ? `disable` : ``} ${props.selected_action == props.basic_action.main_action ? `product-qa-selected` : ``}`} 
                onClick={() => props.basic_action.main_action == 'draw' ? props.selectAction(props.basic_action.main_action) : props.selectAction(props.basic_action.main_action, matchingShapeIcon.main_action)}>
                    {
                        props.basic_action.main_action == 'draw' ?
                            <>
                                <img src={(props.selected_action == props.basic_action.main_action && props.basic_action.selected_icon) ? props.basic_action.selected_icon : props.basic_action.icon} className={`tool-icons ${props.basic_action.main_action == 'draw' ? 'draw' : ''}`} />
                                <div className='tool-box-text-static main-icon'>
                                    <div className={`mb-0 manrope f-12 ${props.objectThickness} tool-box-text-color main-icon ${props.selected_action == props.basic_action.main_action ? 'selected' : ''}`}>
                                    </div>
                                </div>
                            </> :
                            <img src={(props.selected_action == props.basic_action.main_action && matchingShapeIcon.selected_icon) ? matchingShapeIcon.selected_icon : matchingShapeIcon.icon} 
                            className={`tool-icons ${props.basic_action.main_action == 'draw' ? 'draw' : ''}`} />
                    }
                </div>
            </Tooltip>
        
        <Popover overlayClassName="sub-toolbar"
            content={
                <div className='display-flex j-c a-c' style={{ gap: "4px"}}>
                    {props.basic_action.extra_actions.map((extra_action, index) => (                            
                            <Tooltip placement={"top"}
                                key={index}
                                title={<span className='manrope f-12 white'>
                                    {extra_action.tooltip}
                                </span>}>
                                {extra_action.icon_type == "text" ?
                                <div className={`tool-box-text-product ${props.objectThickness == extra_action.main_action ? `product-qa-selected` : ``}`}
                                onClick={() => props.selectAction(props.basic_action.main_action, extra_action.main_action)}>
                                    <div className={`mb-0 manrope f-12 ${extra_action.main_action} ${props.objectThickness == extra_action.main_action ? `selected` : ``} tool-box-text-color`}>
                                    </div>
                                </div> :
                                <div className={`tool-box justify-in-center ${props.objectShape == extra_action.main_action ? `selected-extra` : ``}`}
                                    onClick={() => props.selectAction(props.basic_action.main_action, extra_action.main_action)}>
                                    <img src={props.objectShape == extra_action.main_action ? extra_action.selected_icon : extra_action.icon} className='tool-icons' />
                                </div>}
                            </Tooltip>
                    ))}
                </div>}
            trigger="click"
            open={(props.selected_action === props.basic_action.main_action) &&
                (["text", "shape", "draw"].includes(props.selected_action))}>
                <div className={`${props.annotateLoader || props.save_loader ? `disable` : ``}`}
                style={{padding: '0px 3px', cursor: 'pointer'}}
                onClick={() => props.selectAction(props.basic_action.main_action)}>
                    <DownOutlined/>
                </div>
        </Popover>
        </div>
    )
}

const CanvasToolbar = () => {
    const { selected_action, secondary_selected_action, objectColor, objectThickness,
        selectAction, extraOption, changeColor, onColorClick, initialLoader, refreshLoader,
        access_level, annotateLoader, save_loader, saveAndExit, saveCollaborationData,
         saveExitLoader, setCollabRenderOverrideModal, setCollabSendEmailModal, objectShape, 
         isAiImage, handleImageReject, rejectLoader, userRole, individualCollab } = useContext(CollaborateContext);

    const isMSProivder = (localStorage.getItem("is_msprovider") == "true")
    return (
        <>
        <div className="sentinel" style={{ height: '1px' }}></div>
        <Row className={`collaborate-toolbar display-flex ${initialLoader ? `blur-canvas` : ``}`}>
            <Col span={8} className='display-flex j-s a-c'>
                {(CollaborateConstants.edit_access_levels.includes(access_level)) && 
                <>
                {(isMSProivder) ?
                <Button disabled={initialLoader || refreshLoader || save_loader || annotateLoader} className='basic-collab-btn f-14 ml-8' onClick={() => setCollabRenderOverrideModal(true)}>
                    <span>Render Override</span>
                </Button>:''}
                </>}
            </Col>
            <Col span={isMSProivder ? 9 : 8} className='display-flex j-c a-c' style={{ gap: "2px"}}>
                {(CollaborateConstants.edit_access_levels.includes(access_level)) &&
                    <>
                        {CollaborateConstants.PRODUCT_COLLABORATE_ACTIONS.map((basic_action, index) => (
                            basic_action.extra_actions.length == 0 ?
                                basic_action.icon_type == "color" ?
                                    <Tooltip key={index}
                                        title={<span className='manrope f-12 white'>
                                            {basic_action.tooltip}
                                        </span>}>
                                        <div className="color-input-wrapper-product-qa collab" style={{ '--selected-color': objectColor }}>
                                            <div className="selected-color"></div>
                                            <Input disabled={annotateLoader || save_loader} 
                                            className="object-color-input" type="color" value={objectColor}
                                                onChange={changeColor} onClick={onColorClick} />
                                        </div>
                                    </Tooltip> :
                                    <Tooltip key={index}
                                        title={<span className='manrope f-12 white'>
                                            {basic_action.tooltip}
                                        </span>}>
                                        <div className={`tool-box justify-in-center ${annotateLoader || save_loader ? `disable` : ``} ${selected_action == basic_action.main_action ? `product-qa-selected` : ``}`}
                                            onClick={() => selectAction(basic_action.main_action)}>
                                            {/* <img src={basic_action.icon} className='tool-icons' /> */}
                                                                                        <img src={(selected_action == basic_action.main_action && basic_action.selected_icon) ? basic_action.selected_icon : basic_action.icon} className='tool-icons' />

                                        </div>
                                    </Tooltip> :
                                <MainOptions
                                    key={index}
                                    basic_action={basic_action}
                                    objectThickness={objectThickness}
                                    selected_action={selected_action}
                                    secondary_selected_action={secondary_selected_action}
                                    extraOption={extraOption}
                                    selectAction={selectAction}
                                    annotateLoader={annotateLoader}
                                    save_loader={save_loader}
                                    objectShape={objectShape}
                                />
                        ))}
                        <div className='collab-divider-container'>
                            <div className='collab-tool-divider'></div>
                        </div>
                    </>}

                {access_level != "" && <>
                    {CollaborateConstants.CANVAS_ACTIONS.map((basic_action, index) => (
                        basic_action.main_action == "select" && access_level != "view" ? "" :
                        (basic_action.main_action == "send_email") ?
                        (isMSProivder) ? 
                        <Tooltip
                            key={index}
                            title={<span className='manrope f-12 white'>
                                {basic_action.tooltip}
                            </span>}>
                            <div className={`tool-box justify-in-center ${annotateLoader || save_loader ? `disable` : ``} ${selected_action == "send_email" ? `product-qa-selected` : ``}`}
                                onClick={() => setCollabSendEmailModal(true)}>
                                <img src={basic_action.icon} className='tool-icons' />
                            </div>
                        </Tooltip> : "" :
                        <Tooltip
                            key={index}
                            title={<span className='manrope f-12 white'>
                                {basic_action.tooltip}
                            </span>}>
                            <div className={`tool-box justify-in-center ${annotateLoader || save_loader ? `disable` : ``} ${selected_action == basic_action.main_action ? `product-qa-selected` : ``}`}
                                onClick={() => selectAction(basic_action.main_action, "")}>
                                <img src={basic_action.icon} className='tool-icons' />
                            </div>
                        </Tooltip>
                    ))}
                </>}
            </Col>
            <Col span={isMSProivder ? 7 : 8} className='display-flex j-e a-c'>
            {(CollaborateConstants.edit_access_levels.includes(access_level)) ?
                <>
                {
                    isAiImage && !individualCollab ? 
                    (userRole != 'normal') ?
                    <Button disabled={save_loader || initialLoader || annotateLoader || saveExitLoader || refreshLoader || rejectLoader} className="modal-okay square font-14 ml-8" onClick={handleImageReject}>
                        {rejectLoader ? <span>Submitting Feedback <LoadingOutlined /></span> : <span>Submit Feedback</span>}
                    </Button>
                    : ''
                    :
                    isAiImage && individualCollab ?
                        <Button disabled={save_loader || initialLoader || annotateLoader || saveExitLoader || refreshLoader} className='basic-collab-btn f-14' onClick={saveAndExit}>
                            {saveExitLoader ? <span>Saving <LoadingOutlined /></span> : <span>Save and Exit</span>}
                        </Button>
                    :
                    <>
                        <Button disabled={save_loader || initialLoader || annotateLoader || saveExitLoader || refreshLoader} className='basic-collab-btn f-14' onClick={saveAndExit}>
                            {saveExitLoader ? <span>Saving <LoadingOutlined /></span> : <span>Save and Exit</span>}
                        </Button>
                        <Button disabled={save_loader || initialLoader || annotateLoader || saveExitLoader || refreshLoader} className='basic-collab-btn f-14 ml-8' onClick={saveCollaborationData}>
                            {save_loader ? <span>Saving <LoadingOutlined /></span> : <span>Save</span>}
                        </Button>
                    </>
                }
                </>
            : ''
            }
            </Col>
        </Row>
        </>
    );
}


export default CanvasToolbar;
